const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

/** Origin of the API server (without /api), used for uploaded assets. */
export function getAssetBaseUrl() {
  try {
    const url = new URL(API_URL);
    return `${url.protocol}//${url.host}`;
  } catch {
    return "http://localhost:5000";
  }
}

/**
 * Resolve asset URLs for display.
 * Only prefixes API-hosted uploads (`/uploads/...`).
 * Bundled frontend assets (`/static/...`) stay on the current origin.
 */
export function resolveAssetUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (
    /^https?:\/\//i.test(pathOrUrl) ||
    pathOrUrl.startsWith("blob:") ||
    pathOrUrl.startsWith("data:")
  ) {
    return pathOrUrl;
  }

  const normalized = pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;
  if (normalized.startsWith("/uploads/")) {
    return `${getAssetBaseUrl()}${normalized}`;
  }

  return pathOrUrl;
}
